import { ExternalUrlGroupsListItem, ExternalUrlGroupsSearchModel } from './types-store';

export const ACTION = {
  CLEAR_LIST: 'EXTERNAL_URL_GROUP_LIST:CLEAR_LIST',

  REQUEST_LIST: 'EXTERNAL_URL_GROUP_LIST:REQUEST_LIST',
  RECEIVE_LIST: 'EXTERNAL_URL_GROUP_LIST:RECEIVE_LIST',
  FAIL_LIST: 'EXTERNAL_URL_GROUP_LIST:FAIL_LIST',

  REQUEST_DELETE: 'EXTERNAL_URL_GROUP_LIST:REQUEST_DELETE',
  RECEIVE_DELETE: 'EXTERNAL_URL_GROUP_LIST:RECEIVE_DELETE',
  FAIL_DELETE: 'EXTERNAL_URL_GROUP_LIST:FAIL_DELETE'
};

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public requestId: number) { }
}

export class RequestList {
  public type: string = ACTION.REQUEST_LIST;
  constructor(public requestId: number, public model: ExternalUrlGroupsSearchModel, public clearResults: boolean) { }
}

export class ReceiveList {
  public type: string = ACTION.RECEIVE_LIST;
  constructor(public requestId: number, public list: ExternalUrlGroupsListItem[], public numberOfResults: number) { }
}

export class FailList {
  public type: string = ACTION.FAIL_LIST;
  constructor(public requestId: number) { }
}

export class RequestDeleteExternalUrlGroup {
  public type: string = ACTION.REQUEST_DELETE;
  constructor(public id: number) { }
}

export class ReceiveDeleteExternalUrlGroup {
  public type: string = ACTION.RECEIVE_DELETE;
  constructor(public id: number) { }
}

export class FailDeleteExternalUrlGroup {
  public type: string = ACTION.FAIL_DELETE;
  constructor(public id: number) { }
}
